import {Face,FaceOutlined,SentimentSatisfiedOutlined,SentimentVerySatisfiedOutlined} from '@mui/icons-material';

export const iconsArray = [
  Face,FaceOutlined,SentimentSatisfiedOutlined,SentimentVerySatisfiedOutlined
];
